import * as helper from "../../../store/helpers/customerTag";

import { getCustomerTag, isEnableCustomerTag } from "../../api/customerTag";

/* eslint-disable @typescript-eslint/no-unused-expressions */
import { FailedcustomerTagResponse } from "../../../constants/error_messages";
import { GET_CUSTOMER_TAG } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  serchCustomerList: [] as any,
  customerTagList: [] as any,
  filterTableData: [] as any,
  isUpdateCustomer: false,
  customertagStatus: 0,
  serchValue: "",
  responseError: {
    hasError: false,
    errorMessage: "",
  },
};

const getCustomerTagSlice = createSlice({
  name: GET_CUSTOMER_TAG,
  initialState,
  reducers: {
    updateCustomerList: (state, { payload }) => {
      const index = helper.checkIfExist(state, payload.cid);
      if (index !== -1) {
        const subIndex = helper.checkSearchIfExist(state, payload.cid);
        state.customerTagList.splice(index, 1);
        if (subIndex !== -1) {
          state.serchCustomerList.splice(subIndex, 1);
          if (state.serchCustomerList.length === 0) {
            state.serchCustomerList = state.customerTagList;
            state.serchValue = "";
          }
        }
      }
    },
    updateCustomerListwhileupdate: (state, { payload }) => {
      const index = helper.checkIfExist(state, payload.cid);
      if (index > -1) {
        const subIndex = helper.checkSearchIfExist(state, payload.cid);
        //eslint-disable-next-line @typescript-eslint/no-unused-expressions
        (state.customerTagList[index].customerTagName =
          payload.customerTagName),
          (state.customerTagList[index].description = payload.description),
          (state.customerTagList[index].status = payload.status);
        if (subIndex > -1) {
          //eslint-disable-next-line @typescript-eslint/no-unused-expressions
          (state.serchCustomerList[subIndex].customerTagName =
            payload.customerTagName),
            (state.serchCustomerList[subIndex].description =
              payload.description),
            (state.serchCustomerList[subIndex].status = payload.status);
        }
      }
    },
    updateCustomerTagStatus: (state, { payload }) => {
      const index = helper.checkIfExist(state, payload.cid);
      if (index > -1) {
        const subIndex = helper.checkSearchIfExist(state, payload.cid);
        state.customerTagList[index].status = payload.status;
        if (subIndex > -1) {
          state.serchCustomerList[subIndex].status = payload.status;
        }
      }
    },
    serchCustomerList: (state, { payload }) => {
      state.serchValue = payload;
      if (payload.length < 1) {
        state.serchCustomerList = state.customerTagList;
      } else {
        state.serchCustomerList = state.customerTagList.filter((data: any) => {
          return helper.filterSearch(data, payload);
        });
      }
    },
    customerTagDisable: (state) => {
      state.customertagStatus = state.customertagStatus === 1 ? 0 : 1;
    },
    reset: () => { },
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomerTag.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCustomerTag.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        state.customerTagList = payload.data.getCustomerTagListRes;
        state.customertagStatus = payload.data.getCustomerTagStatus;
        state.serchCustomerList = payload.data.getCustomerTagListRes;
        state.responseError.hasError = false;
        state.responseError.errorMessage = "";
      } else {
        state.responseError.hasError = true;
        state.responseError.errorMessage =
          payload?.message ?? FailedcustomerTagResponse;
      }

      state.loading = false;
    });
    builder.addCase(getCustomerTag.rejected, (state, { payload }: any) => {
      state.responseError.hasError = true;
      state.responseError.errorMessage =
        payload?.message ?? FailedcustomerTagResponse;
      state.loading = false;
    });
    builder.addCase(isEnableCustomerTag.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        state.responseError.hasError = false;
        state.responseError.errorMessage = "";
      } else {
        state.responseError.hasError = true;
        state.responseError.errorMessage =
          payload?.message ?? FailedcustomerTagResponse;
      }
    });
    builder.addCase(isEnableCustomerTag.rejected, (state, { payload }: any) => {
      state.responseError.hasError = true;
      state.responseError.errorMessage =
        payload?.message ?? FailedcustomerTagResponse;
    });
  },
});
export const getCustomerTagAction = getCustomerTagSlice.actions;
export default getCustomerTagSlice.reducer;
